function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["__scopeTabs", "value", "onValueChange", "defaultValue", "orientation", "dir", "activationMode"],
  _excluded2 = ["__scopeTabs", "loop"],
  _excluded3 = ["__scopeTabs", "value", "disabled"],
  _excluded4 = ["__scopeTabs", "value", "forceMount", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var $8oLOM$babelruntimehelpersextends = require("@babel/runtime/helpers/extends");
var $8oLOM$react = require("react");
var $8oLOM$radixuiprimitive = require("@radix-ui/primitive");
var $8oLOM$radixuireactcontext = require("@radix-ui/react-context");
var $8oLOM$radixuireactrovingfocus = require("@radix-ui/react-roving-focus");
var $8oLOM$radixuireactpresence = require("@radix-ui/react-presence");
var $8oLOM$radixuireactprimitive = require("@radix-ui/react-primitive");
var $8oLOM$radixuireactdirection = require("@radix-ui/react-direction");
var $8oLOM$radixuireactusecontrollablestate = require("@radix-ui/react-use-controllable-state");
var $8oLOM$radixuireactid = require("@radix-ui/react-id");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "createTabsScope", function () {
  return $2bbff03427f8eaee$export$355f5bd209d7b13a;
});
$parcel$export(module.exports, "Tabs", function () {
  return $2bbff03427f8eaee$export$b2539bed5023c21c;
});
$parcel$export(module.exports, "TabsList", function () {
  return $2bbff03427f8eaee$export$9712d22edc0d78c1;
});
$parcel$export(module.exports, "TabsTrigger", function () {
  return $2bbff03427f8eaee$export$8114b9fdfdf9f3ba;
});
$parcel$export(module.exports, "TabsContent", function () {
  return $2bbff03427f8eaee$export$bd905d70e8fd2ebb;
});
$parcel$export(module.exports, "Root", function () {
  return $2bbff03427f8eaee$export$be92b6f5f03c0fe9;
});
$parcel$export(module.exports, "List", function () {
  return $2bbff03427f8eaee$export$54c2e3dc7acea9f5;
});
$parcel$export(module.exports, "Trigger", function () {
  return $2bbff03427f8eaee$export$41fb9f06171c75f4;
});
$parcel$export(module.exports, "Content", function () {
  return $2bbff03427f8eaee$export$7c6e2c02157bb7d2;
});

/* -------------------------------------------------------------------------------------------------
 * Tabs
 * -----------------------------------------------------------------------------------------------*/
var $2bbff03427f8eaee$var$TABS_NAME = 'Tabs';
var _$8oLOM$radixuireactc = $8oLOM$radixuireactcontext.createContextScope($2bbff03427f8eaee$var$TABS_NAME, [$8oLOM$radixuireactrovingfocus.createRovingFocusGroupScope]),
  _$8oLOM$radixuireactc2 = _slicedToArray(_$8oLOM$radixuireactc, 2),
  $2bbff03427f8eaee$var$createTabsContext = _$8oLOM$radixuireactc2[0],
  $2bbff03427f8eaee$export$355f5bd209d7b13a = _$8oLOM$radixuireactc2[1];
var $2bbff03427f8eaee$var$useRovingFocusGroupScope = $8oLOM$radixuireactrovingfocus.createRovingFocusGroupScope();
var _$2bbff03427f8eaee$va = $2bbff03427f8eaee$var$createTabsContext($2bbff03427f8eaee$var$TABS_NAME),
  _$2bbff03427f8eaee$va2 = _slicedToArray(_$2bbff03427f8eaee$va, 2),
  $2bbff03427f8eaee$var$TabsProvider = _$2bbff03427f8eaee$va2[0],
  $2bbff03427f8eaee$var$useTabsContext = _$2bbff03427f8eaee$va2[1];
var $2bbff03427f8eaee$export$b2539bed5023c21c = /*#__PURE__*/$8oLOM$react.forwardRef(function (props, forwardedRef) {
  var __scopeTabs = props.__scopeTabs,
    valueProp = props.value,
    onValueChange = props.onValueChange,
    defaultValue = props.defaultValue,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
    dir = props.dir,
    _props$activationMode = props.activationMode,
    activationMode = _props$activationMode === void 0 ? 'automatic' : _props$activationMode,
    tabsProps = _objectWithoutProperties(props, _excluded);
  var direction = $8oLOM$radixuireactdirection.useDirection(dir);
  var _$8oLOM$radixuireactu = $8oLOM$radixuireactusecontrollablestate.useControllableState({
      prop: valueProp,
      onChange: onValueChange,
      defaultProp: defaultValue
    }),
    _$8oLOM$radixuireactu2 = _slicedToArray(_$8oLOM$radixuireactu, 2),
    value = _$8oLOM$radixuireactu2[0],
    setValue = _$8oLOM$radixuireactu2[1];
  return /*#__PURE__*/$8oLOM$react.createElement($2bbff03427f8eaee$var$TabsProvider, {
    scope: __scopeTabs,
    baseId: $8oLOM$radixuireactid.useId(),
    value: value,
    onValueChange: setValue,
    orientation: orientation,
    dir: direction,
    activationMode: activationMode
  }, /*#__PURE__*/$8oLOM$react.createElement($8oLOM$radixuireactprimitive.Primitive.div, $parcel$interopDefault($8oLOM$babelruntimehelpersextends)({
    dir: direction,
    "data-orientation": orientation
  }, tabsProps, {
    ref: forwardedRef
  })));
});
/*#__PURE__*/
Object.assign($2bbff03427f8eaee$export$b2539bed5023c21c, {
  displayName: $2bbff03427f8eaee$var$TABS_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsList
 * -----------------------------------------------------------------------------------------------*/
var $2bbff03427f8eaee$var$TAB_LIST_NAME = 'TabsList';
var $2bbff03427f8eaee$export$9712d22edc0d78c1 = /*#__PURE__*/$8oLOM$react.forwardRef(function (props, forwardedRef) {
  var __scopeTabs = props.__scopeTabs,
    _props$loop = props.loop,
    loop = _props$loop === void 0 ? true : _props$loop,
    listProps = _objectWithoutProperties(props, _excluded2);
  var context = $2bbff03427f8eaee$var$useTabsContext($2bbff03427f8eaee$var$TAB_LIST_NAME, __scopeTabs);
  var rovingFocusGroupScope = $2bbff03427f8eaee$var$useRovingFocusGroupScope(__scopeTabs);
  return /*#__PURE__*/$8oLOM$react.createElement($8oLOM$radixuireactrovingfocus.Root, $parcel$interopDefault($8oLOM$babelruntimehelpersextends)({
    asChild: true
  }, rovingFocusGroupScope, {
    orientation: context.orientation,
    dir: context.dir,
    loop: loop
  }), /*#__PURE__*/$8oLOM$react.createElement($8oLOM$radixuireactprimitive.Primitive.div, $parcel$interopDefault($8oLOM$babelruntimehelpersextends)({
    role: "tablist",
    "aria-orientation": context.orientation
  }, listProps, {
    ref: forwardedRef
  })));
});
/*#__PURE__*/
Object.assign($2bbff03427f8eaee$export$9712d22edc0d78c1, {
  displayName: $2bbff03427f8eaee$var$TAB_LIST_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsTrigger
 * -----------------------------------------------------------------------------------------------*/
var $2bbff03427f8eaee$var$TRIGGER_NAME = 'TabsTrigger';
var $2bbff03427f8eaee$export$8114b9fdfdf9f3ba = /*#__PURE__*/$8oLOM$react.forwardRef(function (props, forwardedRef) {
  var __scopeTabs = props.__scopeTabs,
    value = props.value,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    triggerProps = _objectWithoutProperties(props, _excluded3);
  var context = $2bbff03427f8eaee$var$useTabsContext($2bbff03427f8eaee$var$TRIGGER_NAME, __scopeTabs);
  var rovingFocusGroupScope = $2bbff03427f8eaee$var$useRovingFocusGroupScope(__scopeTabs);
  var triggerId = $2bbff03427f8eaee$var$makeTriggerId(context.baseId, value);
  var contentId = $2bbff03427f8eaee$var$makeContentId(context.baseId, value);
  var isSelected = value === context.value;
  return /*#__PURE__*/$8oLOM$react.createElement($8oLOM$radixuireactrovingfocus.Item, $parcel$interopDefault($8oLOM$babelruntimehelpersextends)({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !disabled,
    active: isSelected
  }), /*#__PURE__*/$8oLOM$react.createElement($8oLOM$radixuireactprimitive.Primitive.button, $parcel$interopDefault($8oLOM$babelruntimehelpersextends)({
    type: "button",
    role: "tab",
    "aria-selected": isSelected,
    "aria-controls": contentId,
    "data-state": isSelected ? 'active' : 'inactive',
    "data-disabled": disabled ? '' : undefined,
    disabled: disabled,
    id: triggerId
  }, triggerProps, {
    ref: forwardedRef,
    onMouseDown: $8oLOM$radixuiprimitive.composeEventHandlers(props.onMouseDown, function (event) {
      // only call handler if it's the left button (mousedown gets triggered by all mouse buttons)
      // but not when the control key is pressed (avoiding MacOS right click)
      if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);else
        // prevent focus to avoid accidental activation
        event.preventDefault();
    }),
    onKeyDown: $8oLOM$radixuiprimitive.composeEventHandlers(props.onKeyDown, function (event) {
      if ([' ', 'Enter'].includes(event.key)) context.onValueChange(value);
    }),
    onFocus: $8oLOM$radixuiprimitive.composeEventHandlers(props.onFocus, function () {
      // handle "automatic" activation if necessary
      // ie. activate tab following focus
      var isAutomaticActivation = context.activationMode !== 'manual';
      if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
    })
  })));
});
/*#__PURE__*/
Object.assign($2bbff03427f8eaee$export$8114b9fdfdf9f3ba, {
  displayName: $2bbff03427f8eaee$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TabsContent
 * -----------------------------------------------------------------------------------------------*/
var $2bbff03427f8eaee$var$CONTENT_NAME = 'TabsContent';
var $2bbff03427f8eaee$export$bd905d70e8fd2ebb = /*#__PURE__*/$8oLOM$react.forwardRef(function (props, forwardedRef) {
  var __scopeTabs = props.__scopeTabs,
    value = props.value,
    forceMount = props.forceMount,
    children = props.children,
    contentProps = _objectWithoutProperties(props, _excluded4);
  var context = $2bbff03427f8eaee$var$useTabsContext($2bbff03427f8eaee$var$CONTENT_NAME, __scopeTabs);
  var triggerId = $2bbff03427f8eaee$var$makeTriggerId(context.baseId, value);
  var contentId = $2bbff03427f8eaee$var$makeContentId(context.baseId, value);
  var isSelected = value === context.value;
  var isMountAnimationPreventedRef = $8oLOM$react.useRef(isSelected);
  $8oLOM$react.useEffect(function () {
    var rAF = requestAnimationFrame(function () {
      return isMountAnimationPreventedRef.current = false;
    });
    return function () {
      return cancelAnimationFrame(rAF);
    };
  }, []);
  return /*#__PURE__*/$8oLOM$react.createElement($8oLOM$radixuireactpresence.Presence, {
    present: forceMount || isSelected
  }, function (_ref) {
    var present = _ref.present;
    return /*#__PURE__*/$8oLOM$react.createElement($8oLOM$radixuireactprimitive.Primitive.div, $parcel$interopDefault($8oLOM$babelruntimehelpersextends)({
      "data-state": isSelected ? 'active' : 'inactive',
      "data-orientation": context.orientation,
      role: "tabpanel",
      "aria-labelledby": triggerId,
      hidden: !present,
      id: contentId,
      tabIndex: 0
    }, contentProps, {
      ref: forwardedRef,
      style: _objectSpread(_objectSpread({}, props.style), {}, {
        animationDuration: isMountAnimationPreventedRef.current ? '0s' : undefined
      })
    }), present && children);
  });
});
/*#__PURE__*/
Object.assign($2bbff03427f8eaee$export$bd905d70e8fd2ebb, {
  displayName: $2bbff03427f8eaee$var$CONTENT_NAME
});
/* ---------------------------------------------------------------------------------------------- */
function $2bbff03427f8eaee$var$makeTriggerId(baseId, value) {
  return "".concat(baseId, "-trigger-").concat(value);
}
function $2bbff03427f8eaee$var$makeContentId(baseId, value) {
  return "".concat(baseId, "-content-").concat(value);
}
var $2bbff03427f8eaee$export$be92b6f5f03c0fe9 = $2bbff03427f8eaee$export$b2539bed5023c21c;
var $2bbff03427f8eaee$export$54c2e3dc7acea9f5 = $2bbff03427f8eaee$export$9712d22edc0d78c1;
var $2bbff03427f8eaee$export$41fb9f06171c75f4 = $2bbff03427f8eaee$export$8114b9fdfdf9f3ba;
var $2bbff03427f8eaee$export$7c6e2c02157bb7d2 = $2bbff03427f8eaee$export$bd905d70e8fd2ebb;